import React, { Component } from "react";
import ReactDOM from "react-dom";
import app from "../base";
import { Link, useHistory } from "react-router-dom";

class EditRental extends Component {
  constructor() {
    super();
    this.ref = app.firestore().collection("rentals");
    this.state = {
      rental_name: "",
      owner: "",
      address: "",
      phone: "",
      email: "",
      location: "",
    };
  }

  componentDidMount() {
    const ref = app
      .firestore()
      .collection("rentals")
      .doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        const rental = doc.data();
        this.setState({
          key: doc.id,
          rental_name: rental.rental_name,
          owner: rental.owner,
          address: rental.address,
          phone: rental.phone,
          email: rental.email,
          location: rental.location,
        });
      } else {
        console.log("No such document!");
      }
    });
  }
  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ rentals: state });
  };

  onSubmit = (e) => {
      
    e.preventDefault();
    const { rental_name, owner, address, phone, email, location } = this.state;
    const updateRef = app
      .firestore()
      .collection("rentals")
      .doc(this.state.key);
    updateRef
      .set({
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      })
      .then((docRef) => {
         const {history} = useHistory();
        this.setState({
          rental_name: "",
          owner: "",
          address: "",
          phone: "",
          email: "",
          location: "",
        });
        history.push("/admin/" + this.props.match.params.id);
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  render() {
    const { rental_name, owner, address, phone, email, location } = this.state;
    return (
      <div class="container">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Edit Rental</h3>
          </div>
          <div class="panel-body">
            <h4>
              <Link to="/admin" class="btn btn-primary">
                Rental List
              </Link>
            </h4>
            <form onSubmit={this.onSubmit}>
              <div class="form-group">
                <label for="rental_name">rental name:</label>
                <input
                  type="text"
                  class="form-control"
                  name="rental_name"
                  value={rental_name}
                  onChange={this.onChange}
                  placeholder="Nama Rentalan"
                />
              </div>
              <div class="form-group">
                <label for="owner">owner name:</label>
                <input
                  type="text"
                  class="form-control"
                  name="owner"
                  value={owner}
                  onChange={this.onChange}
                  placeholder="Nama Pemilik Rentalan"
                />
              </div>
              <div class="form-group">
                <label for="address">Alamatt:</label>
                <textArea
                  class="form-control"
                  name="address"
                  onChange={this.onChange}
                  placeholder="alamat"
                  cols="80"
                  rows="3"
                >
                  {address}
                </textArea>
              </div>
              <div class="form-group">
                <label for="phone">Nomor Handphone:</label>
                <input
                  type="number"
                  class="form-control"
                  name="phone"
                  value={phone}
                  onChange={this.onChange}
                  placeholder="phone"
                />
              </div>
              <div class="form-group">
                <label for="email">Email:</label>
                <input
                  type="text"
                  class="form-control"
                  name="email"
                  value={email}
                  onChange={this.onChange}
                  placeholder="Email"
                />
              </div>

              <div class="form-group">
                <label for="location">Location:</label>
                <input
                  type="text"
                  class="form-control"
                  name="location"
                  value={location}
                  onChange={this.onChange}
                  placeholder="Location"
                />
              </div>
              <button type="submit" class="btn btn-success">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default EditRental;
